export default class SVGDragNDrop {
  // static drag(id) {
  //   d3.drag()
  //     .on('start', () => {
  //       SVGDragNDrop.start(id);
  //     })
  //     .on('drag', () => {
  //       SVGDragNDrop.dragged(id);
  //     })
  //     .on('end', () => {
  //       SVGDragNDrop.end(id);
  //     });
  // }

  static start(element) {
    d3.select(element).raise().classed('is-dragged', true);
  }

  static dragged(element, diff) {

    d3.select(element)
      .attr('x', (d3.event.x - diff.x).toFixed())
      .attr('y', (d3.event.y - diff.y).toFixed());
  }

  static end(element, type, diff) {

    d3.select(element)
      .attr('x', (d3.event.x - diff.x).toFixed())
      .attr('y', (d3.event.y - diff.y).toFixed())
      // neumožňuje v jiných funkcí s tímto objektem dále pracovat,
      // protože pracují s id
      // .attr('id', `${type}-${d3.event.x.toFixed()}-${d3.event.y.toFixed()}`)
      .classed('is-dragged', false);
  }
}
